function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, forwardRef } from "react";
import { Table, Container } from "react-bootstrap";
import { Row, Col, Image, Statistic, Space, DatePicker, Modal, Button, notification } from "antd";
import Moment from "react-moment";
import moment from "moment";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var SalarySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var employees = _ref.employees,
    handler = _ref.handler;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    totalSalaryAmount = _useState2[0],
    setTotalSalaryAmount = _useState2[1];
  var _useState3 = useState(moment()),
    _useState4 = _slicedToArray(_useState3, 2),
    workPeriod = _useState4[0],
    setWorkPeriod = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    idList = _useState8[0],
    setIdList = _useState8[1];
  var mar = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
  var handleGenerateSheet = function handleGenerateSheet() {
    setIsDataLoading(true);
    axios.post(Common.baseApiUrl + "generatesalarysheet", {
      user_id: Common.currentUser.id,
      employees: idList.toString(),
      month: new Date(workPeriod).getMonth(),
      year: new Date(workPeriod).getFullYear(),
      total: totalSalaryAmount
    }).then(function (response) {
      if (response.data.status == 200) {
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
        handler();
      } else {
        notification.error({
          message: "Erreur!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    employees.forEach(function (e) {
      setTotalSalaryAmount(function (prev) {
        return prev + e.base_salary;
      });
      setIdList(function (prev) {
        return [].concat(_toConsumableArray(prev), [e.id]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        gutter: 16,
        children: /*#__PURE__*/_jsxs(Col, {
          span: 24,
          children: [Common.account == 'undefined' && Common.account.logo == null ? /*#__PURE__*/_jsx(Image, {
            preview: false,
            width: "100%",
            src: "/drawables/cl.png"
          }) : /*#__PURE__*/_jsx(Image, {
            preview: false,
            width: "100%",
            src: Common.baseUrl + Common.account.logo
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Moment, {
              date: moment(),
              format: "DD/MM/YYYY H:m"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          span: 24,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "8px",
              color: "#EEE",
              background: "#198391",
              clear: "both"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                children: "ETAT DES SALAIRES"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: mar[new Date(workPeriod).getMonth()] + " " + new Date(workPeriod).getFullYear()
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        gutter: 16,
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              padding: "12px",
              borderRadius: "6px",
              background: "#E8D084",
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("h2", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Montant total",
                  value: totalSalaryAmount,
                  prefix: "GNF"
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 16,
          md: 16,
          children: /*#__PURE__*/_jsxs(Table, {
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "Ref."
                }), /*#__PURE__*/_jsx("th", {
                  children: "Nom"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Fonction"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Montant (Gnf)"
                })]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: employees.map(function (e) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsxs("td", {
                    children: ["#", e.id]
                  }), /*#__PURE__*/_jsx("td", {
                    children: "".concat(e.firstname, " ").concat(e.lastname)
                  }), /*#__PURE__*/_jsx("td", {
                    children: e.job
                  }), /*#__PURE__*/_jsx("td", {
                    children: e.base_salary.toLocaleString("Fr")
                  })]
                }, e.id);
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(DatePicker, {
              picker: "month",
              variant: "borderless",
              onChange: function onChange(date_value, date_string) {
                setWorkPeriod(date_value);
              }
            }), /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              disabled: employees.length < 1,
              type: "link",
              onClick: handleGenerateSheet,
              children: /*#__PURE__*/_jsx("b", {
                children: "CREER L'ETAT DE SALAIRES"
              })
            })]
          })
        })
      })]
    })
  });
});
export default SalarySheet;